<template>
  <div class="Layout">
    <router-view></router-view>
    <van-tabbar
      fixed
      route
      :placeholder="true"
      active-color="#31b158"
      inactive-color="#999"
      :z-index="1000"
      v-if="isShowBar"
    >
      <van-tabbar-item
        v-for="(item,index) in tabbarList"
        :name="index"
        :key="index"
        :to="item.path"
        :replace="false"
      >
        <span>{{item.title}}</span>
        <template #icon="props">
          <img :src="props.active ? item.icon.active : item.icon.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import Cookies from "@/utils/Cookies";
export default {
  name: "Layout",
  data() {
    return {
      role_type:1,//1开单  2//收银
      tabbarList: [],
      hideTab: [0],
      isShowBar:true
    };
  },
  //   watch:{
  //     '$store.state.authList': function () {
  //         var res = this.$store.state.authList
  //         if(res.includes(1) && !res.includes(2)){
  //             this.hideTab= [0]
  //         }else if(res.includes(2)){
  //             this.hideTab= [1]
  //         }else{
  //             this.hideTab= [1]
  //         }
  //     }
  //   },
  beforeRouteEnter(to, from, next) {
      next(vm=>{
    var res_z = JSON.parse(Cookies.get("rule"));
    if (res_z.includes("1") && !res_z.includes("2")) {
      vm.role_type=1
    } else if (res_z.includes("2")) {
      vm.role_type=2
    } else {
      vm.role_type=1
    }
    vm.tabbarList = [
      {
        title: vm.role_type==2?"收银":"开单",
        path: vm.role_type==2?"/openOrder/orderCheckOut":"/openOrder/order",
        icon: {
          active: require(`@/assets/img/tabBar/${vm.role_type==2?"tab-havePay-h.png":"tab-order-h.png"}`),
          inactive: require(`@/assets/img/tabBar/${vm.role_type==2?"tab-havePay-m.png":"tab-order-m.png"}`)
        }
      },
      {
        title: "概况",
        path: "/home",
        icon: {
          active: require("@/assets/img/tabBar/tab-home-h.png"),
          inactive: require("@/assets/img/tabBar/tab-home-m.png")
        }
      },
      {
        title: "管理",
        path: "/manage",
        icon: {
          active: require("@/assets/img/tabBar/tab-manage-h.png"),
          inactive: require("@/assets/img/tabBar/tab-manage-m.png")
        }
      },
      {
        title: "我的",
        path: "/user",
        icon: {
          active: require("@/assets/img/tabBar/tab-user-h.png"),
          inactive: require("@/assets/img/tabBar/tab-user-m.png")
        }
      }
    ];
      })
  },
  created() {
    if(this.$route.path=="/openOrder/orderCheckOut" || this.$route.path=="/openOrder/order"){
      this.isShowBar=false
    }
    var res_z = JSON.parse(Cookies.get("rule"));
    if (res_z.includes('1') && !res_z.includes('2')) {
      this.role_type=1
    } else if (res_z.includes('2')) {
     this.role_type=2
    } else {
     this.role_type=1
    }

    this.tabbarList = [
      {
        title: this.role_type==2?"收银":"开单",
        path:this.role_type==2?"/openOrder/orderCheckOut":"/openOrder/order",
        icon: {
          active: require(`@/assets/img/tabBar/${this.role_type==2?"tab-havePay-h.png":"tab-order-h.png"}`),
          inactive: require(`@/assets/img/tabBar/${this.role_type==2?"tab-havePay-m.png":"tab-order-m.png"}`),
        }
      },
      {
        title: "概况",
        path: "/home",
        icon: {
          active: require("@/assets/img/tabBar/tab-home-h.png"),
          inactive: require("@/assets/img/tabBar/tab-home-m.png")
        }
      },
      {
        title: "管理",
        path: "/manage",
        icon: {
          active: require("@/assets/img/tabBar/tab-manage-h.png"),
          inactive: require("@/assets/img/tabBar/tab-manage-m.png")
        }
      },
      {
        title: "我的",
        path: "/user",
        icon: {
          active: require("@/assets/img/tabBar/tab-user-h.png"),
          inactive: require("@/assets/img/tabBar/tab-user-m.png")
        }
      }
    ];

    // this.$store.authList = JSON.parse(Cookies.get("authList"))
    // var res = JSON.parse(Cookies.get("authList"))
    // if(res.includes(1) && !res.includes(2)){
    //     this.hideTab= [0]
    // }else if(res.includes(2)){
    //     this.hideTab= [1]
    // }else{
    //     this.hideTab= [1]
    // }
  },
};
</script>

<style lang="less" scoped>
.Layout {
  position: relative;
}
</style>